import { createTheme, globalTheme } from '@cld/component-theme';

const { spacing, palette } = globalTheme;

export const theme = createTheme({
  solid: {
    tab: {
      verticalPadding: spacing.sm,
      horizontalPadding: spacing.sm,

      background: {
        color: {
          base: palette.surfaceAlt,
          active: palette.primary,
          disabled: palette.surfaceAlt,
        },
      },
      focus: {
        color: palette.primary,
      },
      font: {
        color: {
          base: palette.contrastLow,
          hover: palette.primary,
          active: palette.primary,
          disabled: palette.contrastHigh,
        },
      },
    },

    layout: {
      fixed: {
        padding: spacing.xs,
      }
    },

    indicator: {
      color: palette.primary,
    },
  },

  thin: {
    tab: {
      verticalPadding: spacing.xxs,
      horizontalPadding: spacing.xs,
    }
  }
});
